import { type ColumnDef, flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import type { PluginProposalAttibutes, PluginProposalData } from "~/interface/plugin";
import styles from "./index.module.scss";

interface TableComponentProps {
  data: PluginProposalData[];
  columns: ColumnDef<PluginProposalData>[];
  updateData: (rowIndex: number, columnId: PluginProposalAttibutes, value: string) => void;
  isEditable: boolean;
}

const PluginProposalTable = ({ data, columns, updateData, isEditable }: TableComponentProps) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <table className={styles["table"]}>
      <thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <th key={header.id}>
                {flexRender(header.column.columnDef.header, header.getContext())}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row, rowIndex) => (
          <tr key={row.id}>
            {row.getVisibleCells().map((cell) => (
              <td key={cell.id}>
                {cell.column.id === "delete" ? (
                  flexRender(cell.column.columnDef.cell, cell.getContext())
                ) : !isEditable && cell.column.id === "プラグイン名" ? (
                  row.original.URL ? (
                    <button
                      type="button"
                      className={styles["link"]}
                      onClick={() => window.open(row.original.URL, "_blank")}
                      style={{ cursor: "pointer", color: "blue" }}
                    >
                      {cell.getValue() as string}
                    </button>
                  ) : (
                    <span className={styles["link"]}>{cell.getValue() as string}</span>
                  )
                ) : (
                  <textarea
                    value={cell.getValue() as string | number}
                    onChange={(e) =>
                      updateData(
                        rowIndex,
                        cell.column.id as PluginProposalAttibutes,
                        e.target.value,
                      )
                    }
                    readOnly={!isEditable}
                    style={{ width: "100%", resize: "none" }}
                  />
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PluginProposalTable;
